<template>
  <div class="container" v-if="requested">
    <TopNavbar :title="storeInfo.title" :bgColor="'bgRed'" />
    <van-swipe class="slide-list" :autoplay="3000" v-if="thumbList.length">
      <van-swipe-item v-for="thumb in thumbList" :key="thumb">
        <img :src="thumb">
      </van-swipe-item>
    </van-swipe>
    <shopinfo v-if="storeInfo" :storeInfo="storeInfo" />
    <TablesInfo v-if="tablesInfo.table" :tablesInfo="tablesInfo" />
    <div class="nodata-container">
      <div class="nodata-svg">
        <div class="row-content"><van-icon name="warning" size="100" color="#ee2d24" /></div>
        <div class="row-content">{{ message || 'there is no content on here'}}</div>
        <div class="row-content">
          <van-button icon="shop" plain hairline type="danger" @click="gotoNewPage">OK</van-button>
          <!-- <van-button icon="star-o" plain hairline type="primary" @click="gotoNewPage">Home</van-button>
          <van-button icon="star-o" plain hairline type="info" @click="gotoNewPage">Back</van-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreMessage } from '@/api/api'
import mockDemo from '@/api/mock'
import { cartMixin } from '@/mixins/cartMixin'
import { mapGetters, mapActions } from 'vuex'
import TopNavbar from '@/components/common/TopNavbar.vue'
import shopinfo from './shopinfo'
import TablesInfo from '@/components/common/TablesInfo.vue'

export default {
  name: 'page404index',
  components: { shopinfo, TablesInfo, TopNavbar },
  data () {
    return {
      requested: false,
      thumbList: [
        'https://congruentmusic.com/wp-content/uploads/2017/12/SOHO-photo-580x280.jpg',
        'https://localporto.com/wp-content/uploads/traditional-restaurant-porto-abadia-1.jpg-580x280.png',
        'https://mitchellharris.com.au/wp-content/uploads/2017/03/Mitchell-Harris-Japanese-580x280.jpg',
        'https://edge.bonnieplants.ca/www/sweet-basil-580x280.jpg',
        'http://vemporaqui.com.br/wp-content/uploads/2019/09/El-Califa-580x280.jpg',
      ],
      storeInfo: {},
      tablesInfo: {
        title: '',
        promo: ''
      },
      message: '',
    };
  },
  created () {
    this.get_data()
  },
  computed: {},
  mixins: [cartMixin],
  methods: {
    async get_data () {
      const queryParams = this.getUrlParams({ do: 'merchant' })
      getStoreMessage('/app/index.php', queryParams).then(res => {
        const { thumbList, tablesInfo, storeInfo, message } = res
        this.thumbList = thumbList || []
        this.tablesInfo = {
          title: tablesInfo.title || ''
          , tel: storeInfo.tel || ''
          , table: tablesInfo, tablezones: {}
          , promo: storeInfo.promo || '',
        }

        this.storeInfo = storeInfo || {}
        this.message = message || ''
        this.requested = true
      }).catch(error => {
        this.$toast('network timeout')
        this.requested = true
      })
    },
    gotoNewPage () {
      window.location.href = "https://fastorder.my"
      // if (this.$route.name !== 'home') {
      //   window.history.back(-1)
      // }
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.container {
  .slide-list {
    margin-top: 36px;
    max-height: 100px;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
  .bgRed {
    background-color: @red !important;
  }
  .nodata-container {
    // box-shadow: 0 17px 20px 10px hsla(0,0%,57.3%,.85), -10px 10px 10px 10px hsla(0,0%,100%,.5);
    box-shadow: 0px -4px 9px 0px hsla(0, 0%, 57.3%, 0.15),
      -10px 10px 10px 10px hsla(0, 0%, 100%, 0.5);
    .nodata-svg {
      width: 80%;
      height: 250px;
      margin: 30px auto;
      background: url('../../assets/nodata.svg') no-repeat 50% 50%;
      background-size: contain;
      .row-content {
        padding-top: 30px;
        color: rgba(0, 0, 0, 0.48);
        button {
          margin: 5px;
        }
      }
    }
  }
}
</style>